import React from "react";
import {
  CmmOrderTableRowData,
  MedicationDecisionResult,
} from "../../../../../../data-model/cmmOrderTableRowData";
import NewDetailsCard from "../../../../../newDetailsCard/newDetailsCard";
import { SubstitutionStatus } from "./medicationLogicElements";

interface MedicationOverviewCardProps {
  rowData?: CmmOrderTableRowData;
  decision?: MedicationDecisionResult;
}

const MedicationOverviewCard: React.FC<MedicationOverviewCardProps> = ({
  rowData,
  decision,
}) => (
  <div className="rounded-xl bg-white p-4">
    <div className="flex flex-wrap gap-y-4">
      <div className="w-1/2">
        <NewDetailsCard
          header="Input Drug Name"
          body={decision?.prescribed_drug_name || rowData?.drugName || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Input Drug Class"
          body={rowData?.drugClass || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Generic Name"
          body={rowData?.genericName || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard header="Brand Name" body={rowData?.brandName || "--"} />
      </div>
    </div>
    <div className="mt-4">
      <SubstitutionStatus allowed={rowData?.isSubstitutionAllowed ?? false} />
    </div>
  </div>
);

export default MedicationOverviewCard;
